import Address from './Address';
import GpsCoordinatesWithAccuracy from './GpsCoordinatesWithAccuracy';

export default class AddressLocationWithAccuracy {
	public address: Address | null = null;
	public gpsCoordinates: GpsCoordinatesWithAccuracy | null = null;

	public constructor() {

	}
};